import { render, staticRenderFns } from "./CourseGrades.vue?vue&type=template&id=0e303e9c"
import script from "./CourseGrades.vue?vue&type=script&lang=ts"
export * from "./CourseGrades.vue?vue&type=script&lang=ts"
import style0 from "./CourseGrades.vue?vue&type=style&index=0&id=0e303e9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports